<template>
    <div class="flex items-center justify-center sm:justify-start gap-3">
        <div
            class="flex-none w-20 h-20 sm:w-16 sm:h-16 lg:w-24 lg:h-24 rounded-lg border border-slate-200 dark:border-slate-600 justify-center items-center flex"
            :class="{
                'bg-slate-200 dark:bg-slate-700': !imgSrc,
                'bg-white dark:bg-slate-800': imgSrc,
            }"
        >
            <ImageLoader class="w-full h-full flex items-center justify-center">
                <template #image>
                    <img
                        class="w-full h-full p-2 object-contain"
                        :src="imgSrc"
                        :alt="name"
                    />
                </template>
                <template #error>
                    <div
                        class="w-full h-full flex items-center justify-center bg-slate-200 dark:bg-slate-700 border-slate-200 dark:border-slate-600 border rounded-lg overflow-none"
                        :title="name"
                    >
                        <div
                            class="sm:hidden flex flex-col items-center justify-center text-center p-1 w-full max-h-full"
                        >
                            <LoungeIcon
                                icon="airplane"
                                class="h-5 w-5 flex-none"
                            />
                            <div
                                class="text-slate-800 dark:text-slate-100 text-xs font-medium leading-tight mt-1 line-clamp-2 px-1"
                            >
                                {{ name }}
                            </div>
                        </div>
                        <div
                            class="hidden sm:flex items-center justify-center w-full h-full"
                        >
                            <LoungeIcon icon="airplane" class="w-8 h-8" />
                        </div>
                    </div>
                </template>
            </ImageLoader>
        </div>
        <div class="hidden sm:flex flex-col min-w-0">
            <div
                class="text-slate-800 dark:text-slate-100 text-sm font-medium leading-tight truncate"
            >
                {{ name }}
            </div>
            <div
                v-if="code"
                class="text-slate-500 dark:text-slate-400 text-xs font-normal leading-none"
            >
                {{ code }}
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import LoungeIcon from '@/components/tools/lounges/partials/lounge-icon/lounge-icon.vue';
import ImageLoader from '@/components/ui/image-loader/image-loader.vue';
const props = defineProps({
    name: {
        type: String,
        required: true,
    },
    code: {
        type: String,
        required: false,
    },
    img: {
        type: Object,
        required: false,
    },
});
const cdnUrl = computed(() => window.cdnUrl);

const imgSrc = computed(() => {
    if (props.img?.url) {
        return props.img.url;
    } else if (props.img?.path && props.img?.file_name) {
        const url = `${cdnUrl.value}/${props.img.path}/${props.img.file_name}`;
        return url;
    }
    return null;
});
</script>
